//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["icon", "label1", "label2", "isActive", "disabled"],
  data() {
    return {
    };
  },
  methods: {
    toggle() {
      this.$emit('clicked');
    }
  },
  computed: {
  displayString() {
    if (this.label2 === false) {
      return "Off"
    } else if (this.label2 === true) {
      return "On"
    } else if (this.label2 === 1) {
      return "1.0"
    } else
    return this.label2
  }
  }
};
